

































































































































































































































































































































































































import Vue from 'vue';
import { toString, toNumber, find } from 'lodash';
import moment from 'moment';
import {
  FullscreenSuccess,
  FullscreenError,
  FullscreenLoading,
} from '@/components/fullscreen-wrapper-components';
import { StepperWrapper } from '@/components/stepper-wrapper-component';
import { TokenReAuth } from '@/components/page-components';
import { DatePicker } from '@/components/form-components';
import {
  DateFormat,
  RouteTracking,
  FormValidation,
  CloseStepperWrapper,
  TriggerRefreshError,
} from '@/mixins';
import store from '@/store';
import { ExtendMixins, LoadingService } from '@/services';
import { EventBus } from '@/event-bus';
import { getContentArea } from '@/contentful';
import InputMaskTypes from '@/directives/input-mask/input-mask-types';
import {
  numeric,
  required,
  requiredIf,
  sameAs,
  maxLength,
} from 'vuelidate/lib/validators';
import { req } from 'vuelidate/lib/validators/common';
import {
  bankAccountNumber,
  exactLength,
  date,
  dateHelpers,
} from '@/validations';
import {
  dateFormat,
  datePickerFormat,
  dialogMaxWidth,
  FDIC_PLAN,
} from '@/constants';
import { AuthService } from '@/services';
import {
  api,
  ACCOUNT_API_SUB_URLS,
  BANK_API_SUB_URLS,
  MEMBER_API_SUB_URLS,
  V2,
} from '@/api';
import {
  AccountActivateHSAFormModel,
  IrsContributionLimitsResponseModel,
  MemberBankAccountResponseModel,
  MemberPersonalInformationResponseModel,
  SelectOption,
  StepperSteps,
  UserModel,
  ContentfulLink,
} from '@/@types/member';
import { Links } from '@/mixins/link-mixin';

interface Data {
  currentStep: number;
  submitIsLoading: boolean;
  showBankAccountErrorMessage: boolean;
  showDepositErrorMessage: boolean;
  showDebitCardErrorMessage: boolean;
  showClosedAccountSuccessMessage: boolean;
  showClosedAccountErrorMessage: boolean;
  showOpenedAccountSuccessMessage: boolean;
  showOpenedAccountErrorMessage: boolean;
  accountIsLoading: boolean;
  hasOpenedAccount: boolean;
  hasClosedAccount: boolean;
  dialogMaxWidth: string;
  welcomeText: string;
  closedAccountSuccessMessage: string;
  closedAccountErrorMessage: string;
  openedAccountErrorMessage: string;
  openedAccountSuccessMessage: string;
  addBankAccountErrorMessage: string;
  scheduleDepositErrorMessage: string;
  addDebitCardErrorMessage: string;
  accountModel: AccountActivateHSAFormModel;
  bankAccount: MemberBankAccountResponseModel;
  termsAndConditions: boolean;
  routingNumberValidated: boolean;
  checkingRoutingNumber: boolean;
  showRoutingNumberError: boolean;
  defaultExpectedPostDate: string;
  taxYearOptions: string[];
  showOverHardLimitModal: boolean;
  hasToken: boolean;
  tokenModal: boolean;
  planType: string;
  custodialAgreementLink: ContentfulLink;
  cashSupplementLink: ContentfulLink;
}

export default ExtendMixins(
  DateFormat,
  RouteTracking,
  FormValidation,
  CloseStepperWrapper,
  TriggerRefreshError,
  Links,
).extend({
  name: 'ActivateHSA',
  beforeRouteEnter(to, from, next) {
    const promises = [
      store.dispatch('getIRSContributionLimits'),
      store.dispatch('getMemberCustomerServiceInformation'),
      store.dispatch('getPersonalInformation'),
      getContentArea([
        'activate-hsa-welcome',
        'activate-hsa-success-closed-account',
        'activate-hsa-error-add-bank-account',
        'activate-hsa-error-schedule-deposit',
        'activate-hsa-error-closed-account',
        'activate-hsa-error-open-account',
        'activate-hsa-error-add-debit-card',
        'activate-hsa-success',
      ]),
    ];
    LoadingService.watchPromises(promises)
      .then((data) => {
        const contentAreas = data[3];
        if (contentAreas) {
          if (contentAreas[0] && contentAreas[0].fields) {
            to.meta.welcomeText = contentAreas[0].fields.content;
          }
          if (contentAreas[1] && contentAreas[1].fields) {
            to.meta.closedAccountSuccessMessage = contentAreas[1].fields.content;
          }
          if (contentAreas[2] && contentAreas[2].fields) {
            to.meta.addBankAccountErrorMessage = contentAreas[2].fields.content;
          }
          if (contentAreas[3] && contentAreas[3].fields) {
            to.meta.scheduleDepositErrorMessage = contentAreas[3].fields.content;
          }
          if (contentAreas[4] && contentAreas[4].fields) {
            to.meta.closedAccountErrorMessage = contentAreas[4].fields.content;
          }
          if (contentAreas[5] && contentAreas[5].fields) {
            to.meta.openedAccountErrorMessage = contentAreas[5].fields.content;
          }
          if (contentAreas[6] && contentAreas[6].fields) {
            to.meta.addDebitCardErrorMessage = contentAreas[6].fields.content;
          }
          if (contentAreas[7] && contentAreas[7].fields) {
            to.meta.openedAccountSuccessMessage = contentAreas[7].fields.content;
          }
        }
        next();
      })
      .catch(() => {
        EventBus.$emit('openModal', 'Error', {
          message: 'global_connection-error',
          action: {
            label: 'global_try-again',
            performAction() {
              location.reload();
            },
          },
          hideCancel: true,
        });
        EventBus.$emit('initialLoadDone');
      });
  },
  data(): Data {
    return {
      currentStep: 1,
      submitIsLoading: false,
      showBankAccountErrorMessage: false,
      showDepositErrorMessage: false,
      showDebitCardErrorMessage: false,
      showClosedAccountSuccessMessage: false,
      showClosedAccountErrorMessage: false,
      showOpenedAccountSuccessMessage: false,
      showOpenedAccountErrorMessage: false,
      accountIsLoading: false,
      hasOpenedAccount: false,
      hasClosedAccount: false,
      dialogMaxWidth,
      welcomeText: this.$route.meta.welcomeText,
      closedAccountSuccessMessage: this.$route.meta.closedAccountSuccessMessage,
      closedAccountErrorMessage: this.$route.meta.closedAccountErrorMessage,
      openedAccountErrorMessage: this.$route.meta.openedAccountErrorMessage,
      openedAccountSuccessMessage: this.$route.meta.openedAccountSuccessMessage,
      addBankAccountErrorMessage: this.$route.meta.addBankAccountErrorMessage,
      scheduleDepositErrorMessage: this.$route.meta.scheduleDepositErrorMessage,
      addDebitCardErrorMessage: this.$route.meta.addDebitCardErrorMessage,
      accountModel: {
        token: '',
        routingNumber: '',
        accountNumber: '',
        confirmAccountNumber: '',
        bankName: '',
        accountType: '',
        oneTimeDeposit: false,
        recurringDeposit: false,
        // One time deposit only
        oneTimeAmount: null,
        expectedPostDate: '',
        taxYear: '',
        // Recurring Deposit only
        recurringAmount: null,
        monthlyDepositDay: 5,
      },
      bankAccount: null,
      termsAndConditions: false,
      routingNumberValidated: false,
      checkingRoutingNumber: false,
      showRoutingNumberError: false,
      defaultExpectedPostDate: '',
      taxYearOptions: [],
      showOverHardLimitModal: false,
      hasToken: false,
      tokenModal: false,
      planType: '',
      custodialAgreementLink: null,
      cashSupplementLink: null,
    };
  },
  validations: {
    accountModel: {
      token: {
        required,
      },
      routingNumber: {
        required,
        exactLength: exactLength(9),
        numeric,
        validRoutingNumber(value): boolean {
          return !req(value) || !this.showRoutingNumberError;
        },
      },
      accountNumber: {
        required,
        bankAccountNumber,
        maxLength: maxLength(17),
      },
      confirmAccountNumber: {
        required,
        sameAs: sameAs('accountNumber'),
      },
      bankName: {
        required,
      },
      accountType: {
        required,
      },
      oneTimeDeposit: {
        required: requiredIf(function(this: any): boolean {
          return !this.accountModel.recurringDeposit;
        }),
      },
      recurringDeposit: {
        required: requiredIf(function(this: any): boolean {
          return !this.accountModel.oneTimeDeposit;
        }),
      },
      // One time deposit only
      oneTimeAmount: {
        required: requiredIf(function(this: any): boolean {
          return this.accountModel.oneTimeDeposit;
        }),
        positiveValue(value): boolean {
          const val = InputMaskTypes.currency.deconstruct(value),
            valNum = parseFloat(val);
          return !req(value) || (!isNaN(valNum) && valNum >= 0);
        },
        minValue(value): boolean {
          const val = InputMaskTypes.currency.deconstruct(value),
            valNum = parseFloat(val);
          return !req(value) || (!isNaN(valNum) && valNum >= 5);
        },
      },
      expectedPostDate: {
        required: requiredIf(function(this: any): boolean {
          return this.accountModel.oneTimeDeposit;
        }),
        date,
        afterDefaultDate(value): boolean {
          return dateHelpers.sameOrAfterDate(this.defaultExpectedPostDate)(
            value,
          );
        },
        beforeEndDate(value): boolean {
          return dateHelpers.sameOrBeforeDate(this.minExpectedPostDate)(value);
        },
      },
      taxYear: {
        required: requiredIf(function(this: any): boolean {
          return this.accountModel.oneTimeDeposit;
        }),
      },
      // Recurring Deposit only
      recurringAmount: {
        required: requiredIf(function(this: any): boolean {
          return this.accountModel.recurringDeposit;
        }),
        positiveValue(value): boolean {
          const val = InputMaskTypes.currency.deconstruct(value),
            valNum = parseFloat(val);
          return !req(value) || (!isNaN(valNum) && valNum >= 0);
        },
      },
      monthlyDepositDay: {
        required: requiredIf(function(this: any): boolean {
          return this.accountModel.recurringDeposit;
        }),
      },
    },
    termsAndConditions: {
      required,
    },
  },
  computed: {
    // Getters
    user(): UserModel {
      return this.$store.getters.user;
    },
    personalInformation(): MemberPersonalInformationResponseModel {
      return this.$store.getters.personalInformation;
    },
    irsLimits(): IrsContributionLimitsResponseModel[] {
      return this.$store.getters.irsLimits.sort((a, b) => {
        return a.taxYear < b.taxYear;
      });
    },

    // Steps
    steps(): StepperSteps[] {
      const stepsArray = [
        // Welcome
        {
          ref: 'welcome',
          name: 'activate-hsa_step_welcome',
          showBack: true,
          isCompleted: false,
          isEditable: false,
        },
      ];

      if (this.hasOpenedAccount) {
        // Account
        stepsArray.push({
          ref: 'account',
          name: 'activate-hsa_step_account',
          showBack: true,
          isCompleted: false,
          isEditable: false,
        });
        // Terms & Conditions
        stepsArray.push({
          ref: 'agreement',
          name: 'activate-hsa_step_agreement',
          showBack: true,
          isCompleted: false,
          isEditable: false,
        });
      }

      // Calculate stepPosition for each step
      return stepsArray.map((step, index) => {
        const newStep: StepperSteps = {} as StepperSteps;
        if (index === 0) {
          newStep.showBack = false;
        }
        newStep.stepPosition = (index + 1).toString();
        return Object.assign(step, newStep);
      });
    },
    // Create steps map
    stepsMap(): any {
      return this.steps.reduce((map, obj) => {
        map[obj.ref] = obj;
        return map;
      }, {});
    },
    stepsDisabled(): boolean {
      return (
        this.showBankAccountErrorMessage ||
        this.showDepositErrorMessage ||
        this.showDebitCardErrorMessage ||
        this.showClosedAccountSuccessMessage ||
        this.showClosedAccountErrorMessage ||
        this.showOpenedAccountSuccessMessage ||
        this.showOpenedAccountErrorMessage ||
        this.submitIsLoading ||
        this.accountIsLoading
      );
    },

    // Form data
    monthlyDepositOptions(): SelectOption[] {
      return [
        {
          text: this.$options.filters.t('activate-hsa_option_1st-of-month'),
          value: 1,
        },
        {
          text: this.$options.filters.t('activate-hsa_option_5th-of-month'),
          value: 5,
        },
        {
          text: this.$options.filters.t('activate-hsa_option_10th-of-month'),
          value: 10,
        },
        {
          text: this.$options.filters.t('activate-hsa_option_15th-of-month'),
          value: 15,
        },
        {
          text: this.$options.filters.t('activate-hsa_option_25th-of-month'),
          value: 25,
        },
      ];
    },
    accountTypeOptions(): SelectOption[] {
      return [
        {
          value: 'Checking',
          text: this.$options.filters.t([
            'activate-hsa_option_checking',
            'bank-accounts_label_checking',
            'global_checking',
          ]),
        },
        {
          value: 'Savings',
          text: this.$options.filters.t([
            'activate-hsa_option_savings',
            'bank-accounts_label_savings',
            'global_savings',
          ]),
        },
      ];
    },
    oneTimeTaxYearEndDate(): string {
      if (!this.accountModel.taxYear) {
        return '';
      }
      const irsLimit = this.irsLimits.find((limit) => {
        return (
          limit.taxYear.toString() === this.accountModel.taxYear.toString()
        );
      });
      return irsLimit.endDate;
    },
    minExpectedPostDate(): string {
      const fiveDaysInFuture = moment(this.defaultExpectedPostDate, dateFormat)
        .add(5, 'days')
        .format(dateFormat);
      return this.oneTimeTaxYearEndDate &&
        moment(fiveDaysInFuture, dateFormat).isAfter(
          moment(this.oneTimeTaxYearEndDate, dateFormat),
        )
        ? this.oneTimeTaxYearEndDate
        : fiveDaysInFuture;
    },
    firstExpectedPullDate(): string {
      if (!this.accountModel.recurringDeposit) {
        return null;
      }
      const todayDay = moment().date(),
        selectedDepositDay = this.accountModel.monthlyDepositDay;
      if (selectedDepositDay < todayDay) {
        return moment()
          .add(1, 'month')
          .date(selectedDepositDay)
          .format(dateFormat);
      } else {
        return moment()
          .date(selectedDepositDay)
          .format(dateFormat);
      }
    },
    pullDateYear(): string {
      return moment(this.firstExpectedPullDate, dateFormat).format('YYYY');
    },
    depositPullsQuantity(): number {
      const pullEndDate = moment(
          `12/31/${this.pullDateYear}`,
          dateFormat,
        ).format(dateFormat),
        monthDiff = Math.round(
          moment(pullEndDate, dateFormat).diff(
            moment(this.firstExpectedPullDate, dateFormat),
            'months',
            true,
          ),
        );
      let pulls = 0;
      for (let i = 0; i < monthDiff; i++) {
        const firstExpectedPullDate = moment(this.firstExpectedPullDate, dateFormat)
          .add(i, 'month')
          .format(dateFormat);
        if (
          moment(firstExpectedPullDate, dateFormat).isSameOrBefore(
            moment(pullEndDate, dateFormat),
          )
        ) {
          pulls++;
        }
      }
      return pulls;
    },
    totalDepositAmount(): number {
      const deconstructedOneTimeAmount = InputMaskTypes.currency.deconstruct(
          this.accountModel.oneTimeAmount,
        ),
        parsedOneTimeAmount = parseFloat(deconstructedOneTimeAmount),
        oneTimeAmount = !isNaN(parsedOneTimeAmount) ? parsedOneTimeAmount : 0;
      if (!this.accountModel.recurringDeposit) {
        return oneTimeAmount;
      }

      const deconstructedRecurringAmount = InputMaskTypes.currency.deconstruct(
          this.accountModel.recurringAmount,
        ),
        parsedRecurringAmount = parseFloat(deconstructedRecurringAmount),
        recurringAmount = !isNaN(parsedRecurringAmount)
          ? parsedRecurringAmount
          : 0;
      return oneTimeAmount + recurringAmount * this.depositPullsQuantity;
    },
    totalDepositAmountIsOverHardLimit(): boolean {
      if (
        !this.accountModel.oneTimeDeposit &&
        !this.accountModel.recurringDeposit
      ) {
        return false;
      }
      const taxYear = this.accountModel.oneTimeDeposit
        ? this.accountModel.taxYear
        : this.pullDateYear;
      const matchingTaxYearsArray = this.irsLimits.filter((limit) => {
        return limit.taxYear.toString() === taxYear;
      });
      const matchingTaxYear = matchingTaxYearsArray[0],
        taxYearMax =
          matchingTaxYear.maxFamilyContribution +
          matchingTaxYear.maxCatchupContribution;
      return this.totalDepositAmount > parseFloat(taxYearMax);
    },

    // VALIDATIONS
    tokenErrors(): string[] {
      const formField = 'accountModel.token';
      return this.FormValidationMixin.constructErrors(formField, [
        this.FormValidationMixin.validateField(
          formField,
          [
            'global_form-error_token_required',
            'global_form-error_default_required',
          ],
          'required',
        ),
      ]);
    },
    routingNumberErrors(): string[] {
      const formField = 'accountModel.routingNumber';
      return this.FormValidationMixin.constructErrors(formField, [
        this.FormValidationMixin.validateField(
          formField,
          [
            'activate-hsa_form-error_routing-number_required',
            'global_form-error_routing-number_required',
            'global_form-error_default_required',
          ],
          'required',
        ),
        this.FormValidationMixin.validateField(
          formField,
          ['activate-hsa_form-error_routing-number_length'],
          'exactLength',
        ),
        this.FormValidationMixin.validateField(
          formField,
          [
            'activate-hsa_form-error_routing-number_invalid-format',
            'global_form-error_default_invalid-format',
          ],
          'numeric',
        ),
        this.FormValidationMixin.validateField(
          formField,
          [
            'activate-hsa_form-error_routing-number_invalid',
            'global_form-error_default_invalid-format',
          ],
          'validRoutingNumber',
        ),
      ]);
    },
    accountNumberErrors(): string[] {
      const formField = 'accountModel.accountNumber';
      return this.FormValidationMixin.constructErrors(formField, [
        this.FormValidationMixin.validateField(
          formField,
          [
            'activate-hsa_form-error_account-number_required',
            'global_form-error_account-number_required',
            'global_form-error_default_required',
          ],
          'required',
        ),
        this.FormValidationMixin.validateField(
          formField,
          [
            'activate-hsa_form-error_account-number_invalid-format',
            'global_form-error_default_invalid-format',
          ],
          'bankAccountNumber',
        ),
        this.FormValidationMixin.validateField(
          formField,
          [
            'activate-hsa_form-error_account-number_maxlength',
            'global_form-error_default_invalid-format',
          ],
          'maxLength',
          { key: 'maxLength', val: 'max' },
        ),
      ]);
    },
    confirmAccountNumberErrors(): string[] {
      const formField = 'accountModel.confirmAccountNumber';
      return this.FormValidationMixin.constructErrors(formField, [
        this.FormValidationMixin.validateField(
          formField,
          [
            'activate-hsa_form-error_confirm-account-number_required',
            'global_form-error_confirm-account-number_required',
            'global_form-error_default_required',
          ],
          'required',
        ),
        this.FormValidationMixin.validateField(
          formField,
          ['activate-hsa_form-error_confirm-account-number_same-as'],
          'sameAs',
        ),
      ]);
    },
    bankNameErrors(): string[] {
      const formField = 'accountModel.bankName';
      return this.FormValidationMixin.constructErrors(formField, [
        this.FormValidationMixin.validateField(
          formField,
          [
            'activate-hsa_form-error_bank-name_required',
            'global_form-error_bank-name_required',
            'global_form-error_default_required',
          ],
          'required',
        ),
      ]);
    },
    accountTypeErrors(): string[] {
      const formField = 'accountModel.accountType';
      return this.FormValidationMixin.constructErrors(formField, [
        this.FormValidationMixin.validateField(
          formField,
          [
            'activate-hsa_form-error_account-type_required',
            'global_form-error_account-type_required',
            'global_form-error_default_required',
          ],
          'required',
        ),
      ]);
    },
    oneTimeAmountErrors(): string[] {
      const formField = 'accountModel.oneTimeAmount';
      return this.FormValidationMixin.constructErrors(formField, [
        this.FormValidationMixin.validateField(
          formField,
          [
            'activate-hsa_form-error_one-time-amount_required',
            'global_form-error_default_required',
          ],
          'required',
        ),
        this.FormValidationMixin.validateField(
          formField,
          'activate-hsa_form-error_one-time-amount_negative',
          'positiveValue',
        ),
        this.FormValidationMixin.validateField(
          formField,
          'activate-hsa_form-error_one-time-amount_min-value',
          'minValue',
        ),
      ]);
    },
    expectedPostDateErrors(): string[] {
      const formField = 'accountModel.expectedPostDate';
      return this.FormValidationMixin.constructErrors(formField, [
        this.FormValidationMixin.validateField(
          formField,
          [
            'activate-hsa_form-error_expected-post-date_required',
            'global_form-error_default_required',
          ],
          'required',
        ),
        this.FormValidationMixin.validateField(
          formField,
          [
            'activate-hsa_form-error_expected-post-date_date',
            'global_form-error_date_invalid-format',
            'global_form-error_default_invalid-format',
          ],
          'date',
        ),
        this.FormValidationMixin.validateField(
          formField,
          'activate-hsa_form-error_expected-post-date_after-default-date',
          'afterDefaultDate',
          { key: 'compareDate', val: 'compareDate' },
        ),
        this.FormValidationMixin.validateField(
          formField,
          'activate-hsa_form-error_expected-post-date_before-end-date',
          'beforeEndDate',
          { key: 'compareDate', val: 'compareDate' },
        ),
      ]);
    },
    taxYearErrors(): string[] {
      const formField = 'accountModel.taxYear';
      return this.FormValidationMixin.constructErrors(formField, [
        this.FormValidationMixin.validateField(
          formField,
          [
            'activate-hsa_form-error_tax-year_required',
            'global_form-error_default_required',
          ],
          'required',
        ),
      ]);
    },
    recurringAmountErrors(): string[] {
      const formField = 'accountModel.recurringAmount';
      return this.FormValidationMixin.constructErrors(formField, [
        this.FormValidationMixin.validateField(
          formField,
          [
            'activate-hsa_form-error_recurring-amount_required',
            'global_form-error_default_required',
          ],
          'required',
        ),
        this.FormValidationMixin.validateField(
          formField,
          'activate-hsa_form-error_recurring-amount_negative',
          'positiveValue',
        ),
      ]);
    },
    monthlyDepositDayErrors(): string[] {
      const formField = 'accountModel.monthlyDepositDay';
      return this.FormValidationMixin.constructErrors(formField, [
        this.FormValidationMixin.validateField(
          formField,
          [
            'activate-hsa_form-error_monthly-deposit-day_required',
            'global_form-error_default_required',
          ],
          'required',
        ),
      ]);
    },
    termsAndConditionsErrors(): string[] {
      const formField = 'termsAndConditions';
      return this.FormValidationMixin.constructErrors(formField, [
        this.FormValidationMixin.validateField(
          formField,
          [
            'activate-hsa_form-error_terms-and-conditions_required',
            'global_form-error_terms-and-conditions_required',
            'global_form-error_default_required',
          ],
          'required',
        ),
      ]);
    },
  },
  beforeMount() {
    this.setDefaultExpectedPostDate();
    this.constructShowErrorModel('accountModel');
    this.showErrorModel.termsAndConditions = false;
  },
  methods: {
    setTokenFocus(): void {
      if (this.$refs.token && this.hasToken) {
        setTimeout(() => {
          (this.$refs.token as any).focus();
        }, 350);
      }
    },
    openTokenModal(): void {
      this.tokenModal = true;
    },
    refreshPage(): void {
      location.reload();
    },
    logOut(): void {
      this.refreshHeaders()
        .then(() => {
          AuthService.signOutUser(true);
        })
        .catch(() => {
          this.triggerRefreshError({
            message: [
              'activate-hsa_text_refresh-data-error-message_closed-account',
              'global_connection-error',
            ],
          });
        });
    },
    nextStep(): void {
      this.$v.$reset();
      this.changeMade = true;
      if (this.currentStep < this.steps.length) {
        this.steps[this.currentStep - 1].isCompleted = true;
        this.currentStep++;
        if (
          this.stepsMap.account &&
          this.currentStep === this.stepsMap.account.stepPosition
        ) {
          this.setTokenFocus();
        }
      }
    },
    setStep(step): void {
      if (parseInt(step, 10) === 1) {
        this.hasOpenedAccount = false;
        this.hasClosedAccount = false;
      }
      this.currentStep = step;
      if (
        this.stepsMap.account &&
        this.currentStep === this.stepsMap.account.stepPosition
      ) {
        this.setTokenFocus();
      }
    },
    openAccount(): void {
      this.hasOpenedAccount = true;
      this.$nextTick(() => {
        if (!this.hasToken) {
          this.openTokenModal();
        }
        this.nextStep();
      });
    },
    closeAccount(): void {
      this.hasOpenedAccount = false;
      this.accountIsLoading = true;
      api
        .patch(
          `${ACCOUNT_API_SUB_URLS.accounts}/${
            this.user.memberAccountKey
          }/close?activateCoverage=false&memberId=${this.user.memberId}`,
        )
        .then(() => {
          this.hasClosedAccount = true;
          this.hideCloseAccountErrors();
          this.showClosedAccountSuccessMessage = true;
          this.accountIsLoading = false;
        })
        .catch(() => {
          this.hideCloseAccountErrors();
          this.showClosedAccountErrorMessage = true;
          this.accountIsLoading = false;
        });
    },
    refreshHeaders(): Promise<any> {
      return this.$store.dispatch('getMemberHeader', this.user.memberId);
    },
    goToAccounts(): void {
      this.refreshHeaders()
        .then(() => {
          // @ts-ignore
          this.$router.go({ name: 'accounts' });
        })
        .catch(() => {
          this.triggerRefreshError({
            message: [
              'activate-hsa_text_refresh-data-error-message_navigate-to-accounts',
              'global_connection-error',
            ],
          });
        });
    },

    // Form methods
    validateRoutingNumber(): void {
      this.showRoutingNumberError = false;
      if (this.$v.accountModel.routingNumber.$dirty) {
        if (!this.$v.accountModel.routingNumber.$invalid) {
          this.checkingRoutingNumber = true;
          this.$store
            .dispatch('validateRoutingNumber', this.accountModel.routingNumber)
            .then((data) => {
              this.checkingRoutingNumber = false;
              this.routingNumberValidated = true;
              this.showRoutingNumberError = false;
              this.accountModel.routingNumber = data.routingNumber;
              this.accountModel.bankName = data.bankName;
              this.triggerBlur('accountModel.routingNumber');
            })
            .catch(() => {
              this.showRoutingNumberError = true;
              this.routingNumberValidated = false;
              this.checkingRoutingNumber = false;
              this.triggerBlur('accountModel.routingNumber');
            });
        } else {
          this.accountModel.bankName = '';
          this.triggerBlur('accountModel.routingNumber');
        }
      } else {
        this.triggerBlur('accountModel.routingNumber');
      }
    },
    deconstructAccountNumber(): void {
      this.accountModel.accountNumber = InputMaskTypes.bankAccountNumber.deconstruct(
        this.accountModel.accountNumber,
      );
    },
    getDefaultExpectedPostDate(): string {
      const today = moment().day();
      if (today === 5) {
        return moment()
          .add(1, 'week')
          .day(1)
          .format(dateFormat);
      } else {
        return moment()
          .day(today + 1)
          .format(dateFormat);
      }
    },
    setDefaultExpectedPostDate(): void {
      this.defaultExpectedPostDate = this.getDefaultExpectedPostDate();
      this.accountModel.expectedPostDate = this.defaultExpectedPostDate;
      this.updateDateDependentFields();
    },
    updatePostDate(postDate): void {
      this.accountModel.expectedPostDate = this.formatDate(postDate);
      this.triggerBlur('accountModel.expectedPostDate');
      this.updateHasChanged();
      this.updateDateDependentFields();
    },
    blurPostDate(): void {
      this.triggerBlur('accountModel.expectedPostDate');
      this.updateHasChanged();
      this.updateDateDependentFields();
    },
    updateDateDependentFields(): void {
      this.$nextTick(() => {
        if (!this.$v.accountModel.expectedPostDate.$invalid) {
          this.setTaxYear();
          this.updateTaxYearOptions();
        }
      });
    },
    updateTaxYearOptions(): void {
      let validLimits = [];
      if (this.accountModel.expectedPostDate) {
        validLimits = this.irsLimits.filter((limit) => {
          const startDate = moment(limit.startDate, dateFormat),
            endDate = moment(limit.endDate, dateFormat);
          return (
            moment(
              this.accountModel.expectedPostDate,
              dateFormat,
            ).isSameOrAfter(startDate) &&
            moment(
              this.accountModel.expectedPostDate,
              dateFormat,
            ).isSameOrBefore(endDate)
          );
        });
      }
      this.taxYearOptions = validLimits.length
        ? validLimits.reduce((map, limit) => {
            map.push(limit.taxYear.toString());
            return map;
          }, [])
        : [];
    },
    setTaxYear(): void {
      const taxYearAvailable =
        this.taxYearOptions.indexOf(this.accountModel.taxYear) !== -1;
      if (!this.accountModel.taxYear || !taxYearAvailable) {
        this.accountModel.taxYear = moment(
          this.accountModel.expectedPostDate,
          dateFormat,
        )
          .format('YYYY')
          .toString();
        this.triggerBlur('accountModel.taxYear');
      }
    },
    deconstructExpectedPostDate(): void {
      this.accountModel.expectedPostDate = InputMaskTypes.date.deconstruct(
        this.accountModel.expectedPostDate,
      );
    },
    allowedExpectedPostDates(postDate): boolean {
      if (!this.oneTimeTaxYearEndDate) {
        return true;
      }
      const isAfterDefaultDate = moment(postDate, datePickerFormat).isSameOrAfter(
          moment(this.defaultExpectedPostDate, dateFormat),
          'day',
        ),
        isBeforeMinExpectedPostDate = moment(
          postDate,
          datePickerFormat,
        ).isSameOrBefore(moment(this.minExpectedPostDate, dateFormat), 'day');
      return isAfterDefaultDate && isBeforeMinExpectedPostDate;
    },
    async validateTotalDepositAmount(): Promise<void> {
      if (this.totalDepositAmountIsOverHardLimit) {
        this.showOverHardLimitModal = true;
      } else {
        await this.getTermsAndConditions();
        this.nextStep();
      }
    },
    async getTermsAndConditions(): Promise<void> {
      await this.getDefaultPlanType();
      const cashSupplementCA = this.planType === FDIC_PLAN ?
        'hsa-custodial-agreement-supplement-fdic-insured-cash-supplement' :
        'hsa-custodial-agreement-supplement-paclife-cash-supplement';
      const promises = [
        getContentArea([
          'hsa-custodial-agreement',
          cashSupplementCA,
        ]),
      ];
      const contentAreaResponse = await LoadingService.watchPromises(promises);
      const contentAreas = contentAreaResponse[0];
      if (contentAreas) {
        if (contentAreas[0] && contentAreas[0].fields) {
          this.custodialAgreementLink = this.parseContentfulLink(contentAreas[0].fields);
        }
        if (contentAreas[1] && contentAreas[1].fields) {
          this.cashSupplementLink = this.parseContentfulLink(contentAreas[1].fields);
        }
      }
      Vue.nextTick(() => {
        this.setLinksClickTrackerFunctionality('termsAndConditionsDiv');
      });
    },
    // REST-047b
    async getDefaultPlanType(): Promise<void> {
      const response = await api.get(
          `${ACCOUNT_API_SUB_URLS.accounts}/${
            this.user.memberAccountKey
          }/plan-types${V2}?memberId=${this.user.memberId}`,
        );
      if (response.data) {
        const defaultPlan = find(response.data, {isDefaultPlan: true});
        this.planType = defaultPlan ? defaultPlan.planType : '';
      }
    },
    submitForm(): void {
      this.submitIsLoading = true;
      api
        .patch(
          `${ACCOUNT_API_SUB_URLS.accounts}/${
            this.user.memberAccountKey
          }/close?activateCoverage=true&memberId=${this.user.memberId}`,
        )
        .then(() => {
          this.submitBankingInformation();
        })
        .catch(() => {
          this.submitIsLoading = false;
          this.showOpenedAccountErrorMessage = true;
        });
    },
    submitBankingInformation(): void {
      this.submitIsLoading = true;
      const payload = {
        bankName: this.accountModel.bankName,
        routingNumber: this.accountModel.routingNumber,
        accountNumber: this.accountModel.accountNumber,
        accountType: this.accountModel.accountType,
        useForClaims: true,
        useForContributions: true,
      };
      this.submitIsLoading = true;
      api
        .post(
          `${BANK_API_SUB_URLS.members}/${
            this.user.memberId
          }/bank-accounts`,
          payload,
          {
            headers: {
              'x-token': this.accountModel.token,
            },
          },
        )
        .then((bankAccount) => {
          if (
            this.accountModel.oneTimeDeposit ||
            this.accountModel.recurringDeposit
          ) {
            // If there's a deposit option set, schedule the deposits
            this.bankAccount = bankAccount.data;
            this.scheduleDeposits();
          } else {
            // If there are no deposits to add, add the debit card
            this.addDebitCard();
          }
        })
        .catch(() => {
          this.hideSubmitErrors();
          this.showBankAccountErrorMessage = true;
          this.submitIsLoading = false;
        });
    },
    scheduleDeposits(): void {
      this.submitIsLoading = true;
      if (this.accountModel.oneTimeDeposit) {
        this.addScheduledDeposit(true);
      } else if (
        !this.accountModel.oneTimeDeposit &&
        this.accountModel.recurringDeposit
      ) {
        this.addScheduledDeposit(false);
      }
    },
    addScheduledDeposit(isOneTimeDeposit): void {
      this.submitIsLoading = true;
      const payload = {
        accountId: toString(this.user.memberAccountKey),
        bankId: toString(this.bankAccount.id),
        amount: isOneTimeDeposit
          ? toNumber(this.accountModel.oneTimeAmount)
          : toNumber(this.accountModel.recurringAmount),
        taxYear: isOneTimeDeposit
          ? toString(this.accountModel.taxYear)
          : toString(this.pullDateYear),
        pullDate: isOneTimeDeposit
          ? moment(this.accountModel.expectedPostDate, dateFormat).format(datePickerFormat)
          : moment(this.firstExpectedPullDate, dateFormat).format(datePickerFormat),
        isOneTime: isOneTimeDeposit,
      };
      this.$store
        .dispatch('addScheduledDeposit', payload)
        .then(() => {
          if (isOneTimeDeposit && this.accountModel.recurringDeposit) {
            // If this call is scheduling the one time deposit and there is a still a recurring deposit,
            // call addScheduledDeposit to post the recurring deposit
            this.addScheduledDeposit(false);
          } else {
            // If this recurring deposit or there is no recurring deposit to submit,
            // add the debit card
            this.addDebitCard();
          }
        })
        .catch(() => {
          // If adding a scheduled deposit fails, show the deposit error message
          this.hideSubmitErrors();
          this.showDepositErrorMessage = true;
          this.submitIsLoading = false;
        });
    },
    addDebitCard(): void {
      this.submitIsLoading = true;
      const payload = {
        dependentId: null,
        cardPackageId: null,
        memberId: this.user.memberId,
      };
      api
        .post(
          `${MEMBER_API_SUB_URLS.dependents}/debit-cards-v2`,
          payload,
        )
        .then(() => {
          this.hideSubmitErrors();
          this.showOpenedAccountSuccessMessage = true;
          this.submitIsLoading = false;
        })
        .catch(() => {
          this.hideSubmitErrors();
          this.showDebitCardErrorMessage = true;
          this.submitIsLoading = false;
        });
    },
    hideSubmitErrors(): void {
      this.showOpenedAccountErrorMessage = false;
      this.showBankAccountErrorMessage = false;
      this.showDepositErrorMessage = false;
      this.showDebitCardErrorMessage = false;
    },
    hideCloseAccountErrors(): void {
      this.showClosedAccountErrorMessage = false;
      this.showClosedAccountSuccessMessage = false;
    },
  },
  components: {
    TokenReAuth,
    DatePicker,
    StepperWrapper,
    FullscreenSuccess,
    FullscreenError,
    FullscreenLoading,
  },
});
